import { useCallback, useState } from 'react';

import { DISABLED_LANGUAGES, E_LANGUAGE } from '@common/configs';

export const useLanguageSwitch = () => {
  const languages = Object.values(E_LANGUAGE) as E_LANGUAGE[];
  const [language, setLanguage] = useState<E_LANGUAGE>(languages[0]);

  const changeLanguage = useCallback((lang: E_LANGUAGE) => {
    if (DISABLED_LANGUAGES.includes(lang)) {
      return;
    }
    setLanguage(lang);
  }, []);

  return { language, changeLanguage, languages, disabledLanguages: DISABLED_LANGUAGES };
};
